__turbopack_context__.v({
  "Arrow": "AccountMenu-module-scss-module__v37Dxq__Arrow",
  "ArrowFill": "AccountMenu-module-scss-module__v37Dxq__ArrowFill",
  "ArrowInnerStroke": "AccountMenu-module-scss-module__v37Dxq__ArrowInnerStroke",
  "ArrowOuterStroke": "AccountMenu-module-scss-module__v37Dxq__ArrowOuterStroke",
  "Avatar": "AccountMenu-module-scss-module__v37Dxq__Avatar",
  "Button": "AccountMenu-module-scss-module__v37Dxq__Button",
  "Fallback": "AccountMenu-module-scss-module__v37Dxq__Fallback",
  "HelpIcon": "AccountMenu-module-scss-module__v37Dxq__HelpIcon",
  "Image": "AccountMenu-module-scss-module__v37Dxq__Image",
  "Item": "AccountMenu-module-scss-module__v37Dxq__Item",
  "Popup": "AccountMenu-module-scss-module__v37Dxq__Popup",
  "Positioner": "AccountMenu-module-scss-module__v37Dxq__Positioner",
  "Separator": "AccountMenu-module-scss-module__v37Dxq__Separator",
  "SeparatorWrapper": "AccountMenu-module-scss-module__v37Dxq__SeparatorWrapper",
  "absolute": "AccountMenu-module-scss-module__v37Dxq__absolute",
  "itemSub": "AccountMenu-module-scss-module__v37Dxq__itemSub",
  "notificationsCount": "AccountMenu-module-scss-module__v37Dxq__notificationsCount",
});
